import { RcClasses } from '../../../../foundation';
export var RcAccordionDetailsClasses = RcClasses([], 'RcAccordionDetails');
